import React, { useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import styles from './ExperimentInfo.scss';
import { Button } from '@miroculus/nucleo';
import { secondsToTime } from 'utils';
const cx = classnames.bind(styles);
const ExperimentInfo = ({ startedAt = Date.now(), name, onFinishClick, connected, }) => {
    const [runningTime, setRunningTime] = useState((Date.now() - startedAt) / 1000);
    const { h, m, s } = secondsToTime(runningTime);
    useEffect(() => {
        const interval = setInterval(() => {
            setRunningTime((Date.now() - startedAt) / 1000);
        }, 1000);
        return () => clearInterval(interval);
    }, [startedAt]);
    return (React.createElement("div", { className: cx('footer') },
        React.createElement("div", { className: cx('name') }, name),
        React.createElement("div", { className: cx('runningTime') },
            "Running time: ",
            startedAt ? `${h}:${m}:${s}` : '00:00:00'),
        React.createElement(Button, { onClick: onFinishClick, disabled: !connected }, "Finish")));
};
export default ExperimentInfo;
